import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

const domPageScript = document.createElement('script');
domPageScript.src = `${environment.netPlusDomain}/frontal/scripts/DomPage.v1.js`;
domPageScript.type = 'text/javascript';
domPageScript.defer = true;
document.head.appendChild(domPageScript);

platformBrowserDynamic().bootstrapModule(AppModule);
